import { c as _c } from "react/compiler-runtime";
import { HotelReserveCardCancellationModalType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal/hotel-reserve-card-cancellation-modal.types";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { replaceOptions } from "@website/utils/replace-options";
export const useHotelreservecardCancellationModal = properties => {
  const $ = _c(17);
  const {
    onClose,
    open,
    bundleId
  } = properties;
  let t0;
  let t1;
  if ($[0] !== bundleId) {
    t0 = [bundleId];
    t1 = () => fetcher({
      url: replaceOptions(`${process.env.NEXT_PUBLIC_BASE_URL_API}/bookings/room-policies?reserveToken={bundleId}`, {
        bundleId
      })
    });
    $[0] = bundleId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = open && Boolean(bundleId);
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      refetchOnMount: "always"
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: policies,
    isLoading
  } = useFetcher(t3);
  let t4;
  if ($[7] !== onClose || $[8] !== open) {
    t4 = {
      open,
      onClose,
      showCloseButton: false,
      mobileHeight: "auto" as const,
      animate: "bottom" as const
    };
    $[7] = onClose;
    $[8] = open;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = policies?.data?.data?.policies as Array<string>;
  let t6;
  if ($[10] !== onClose) {
    t6 = {
      size: "large" as const,
      children: "\u0645\u062A\u0648\u062C\u0647 \u0634\u062F\u0645",
      color: "secondary" as const,
      fullWidth: true,
      onClick: onClose
    };
    $[10] = onClose;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isLoading || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = {
      modalProps: t4,
      title: "\u0642\u0648\u0627\u0646\u06CC\u0646 \u06A9\u0646\u0633\u0644\u06CC",
      policies: t5,
      isLoading,
      buttonProps: t6
    };
    $[12] = isLoading;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};